enum IncomeFrequencyEnum {
    Weekly = 'weekly',
    Monthly = 'monthly',
    Annual = 'annual',
}

export default IncomeFrequencyEnum;
